"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeStickyTopBar = void 0;
var React = require("react");
var classnames_1 = require("classnames");
exports.placeStickyTopBar = function (props) {
    var stickyClasses = classnames_1.default('c-sticky-menu--sticky', 't--contrast', {
        'c-sticky-menu--lite': !props.isSticky,
    });
    var headerClassName = classnames_1.default([
        'c-sticky-menu__item c-sticky-menu__item--title',
        'c-sticky-menu__link c-sticky-menu__link--nounder',
    ]);
    var renderTopPlaces = function (props) { return (React.createElement("a", { id: "prop-topplace-anchor", href: "#place-topplace", className: "c-sticky-menu__item c-sticky-menu__item--secondary" },
        React.createElement("span", { className: "c-sticky-menu__link" }, props.t.topPlace))); };
    var rennderNeighbourhoodButton = function (props) {
        if (props.showContactCta)
            return;
        return (React.createElement("a", { id: "prop-neighbourhood-anchor", href: "#place-neighbourhood", className: "c-sticky-menu__item c-sticky-menu__item--secondary" },
            React.createElement("span", { className: "c-sticky-menu__link" }, props.t.neighbourhood)));
    };
    var renderAvailableListingButton = function (props) {
        if (!props.availablePropertiesRent.length && !props.availablePropertiesSale.length)
            return '';
        return (React.createElement("a", { id: "prop-listing-anchor", href: "#place-listing", className: "c-sticky-menu__item c-sticky-menu__item--secondary" },
            React.createElement("span", { className: "c-sticky-menu__link" }, props.t.availableListings)));
    };
    var renderListYourProeprtyButton = function (props) {
        if (!props.showContactCta)
            return;
        return (React.createElement("a", { id: "list-your-property-anchor", href: "#list-your-property", className: "c-sticky-menu__item c-sticky-menu__item--secondary" },
            React.createElement("span", { className: "c-sticky-menu__link" }, props.t.listYourProperty)));
    };
    var follow = props.saveSearchId > -1 ? props.t.unfollowPlace
        : props.t.followPlace;
    var followClicked = function () {
        if (props.saveSearchId === -1)
            return props.followClicked();
        return props.unfollowClicked();
    };
    var renderSmallFollowButton = function (props) {
        if (props.isDemolished)
            return null;
        return (React.createElement("a", { id: "prop-follow-btn-sm", onClick: followClicked, className: "c-sticky-menu__link" }, follow));
    };
    var renderSmallContactButton = function (props) {
        return props.showContactCta ? (React.createElement("a", { id: "prop-contact-btn-sm", onClick: props.onEnquireClicked, className: "u-mobile-hidden c-sticky-menu__link c-sticky-menu__link--primary" }, props.t.contactAgent)) : null;
    };
    return (React.createElement("div", { id: "stickytopbar", className: stickyClasses },
        React.createElement("div", { className: "c-sticky-menu__container" },
            React.createElement("div", { className: "l-container l-container--lr l-container--compact" },
                React.createElement("div", { className: "l-container__main c-sticky-menu__group" },
                    React.createElement("div", { className: "c-sticky-menu__group-main" },
                        React.createElement("a", { id: "prop-sticky-name", className: headerClassName, href: "#" },
                            props.name,
                            " ",
                            props.nameAlt))),
                React.createElement("div", { className: "l-container__side c-sticky-menu__group" },
                    React.createElement("div", { className: "c-sticky-menu__group-side" },
                        props.topPlaces && props.topPlaces.length ? renderTopPlaces(props) : '',
                        props.lat ? rennderNeighbourhoodButton(props) : '',
                        renderAvailableListingButton(props),
                        renderListYourProeprtyButton(props),
                        React.createElement("div", { className: "c-sticky-menu__item c-sticky-menu__item--primary" },
                            renderSmallFollowButton(props),
                            renderSmallContactButton(props))))))));
};
